import axios from "axios";
// import router from '../routerManuaConfig'
import router from "../router/index";
import store from "../store";
import Vue from "vue";

import applicationUserManager from "../Auth/applicationusermanager";

// let base = "";
// 如果是IIS部署，用这个，因为 IIS 只能是 CORS 跨域，不能代理
// let base = process.env.NODE_ENV=="production"? 'http://localhost:8081':'';
let base =
  // process.env.NODE_ENV == "production" ? "http://192.168.80.76:8081" : "";
  // process.env.NODE_ENV == "production" ? "http://58.220.5.124:7001" : ""; //76
  process.env.NODE_ENV == "production" ? "http://180.110.202.114:6002" : ""; //云76
// 请求延时
axios.defaults.timeout = 20000;

var storeTemp = store;
axios.interceptors.request.use(
  (config) => {
    var curTime = new Date();
    var expiretime = new Date(Date.parse(storeTemp.state.tokenExpire));

    if (
      storeTemp.state.token &&
      curTime < expiretime &&
      storeTemp.state.tokenExpire
    ) {
      // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers.Authorization = "Bearer " + storeTemp.state.token;
    }

    saveRefreshtime();

    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);

// http response 拦截器
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // 超时请求处理
    var originalRequest = error.config;
    if (
      error.code == "ECONNABORTED" &&
      error.message.indexOf("timeout") != -1 &&
      !originalRequest._retry
    ) {
      Vue.prototype.$message({
        message: "请求超时！",
        type: "error",
      });

      originalRequest._retry = true;
      return null;
    }

    if (error.response) {
      if (error.response.status == 401) {
        var curTime = new Date();
        var refreshtime = new Date(Date.parse(window.localStorage.refreshtime));
        // 在用户操作的活跃期内
        if (window.localStorage.refreshtime && curTime <= refreshtime) {
          return refreshToken({ token: window.localStorage.Token }).then(
            (res) => {
              if (res.success) {
                Vue.prototype.$message({
                  message: "refreshToken success! loading data...",
                  type: "success",
                });

                store.commit("saveToken", res.response.token);

                var curTime = new Date();
                var expiredate = new Date(
                  curTime.setSeconds(
                    curTime.getSeconds() + res.response.expires_in
                  )
                );
                store.commit("saveTokenExpire", expiredate);

                error.config.__isRetryRequest = true;
                error.config.headers.Authorization =
                  "Bearer " + res.response.token;
                return axios(error.config);
              } else {
                // 刷新token失败 清除token信息并跳转到登录页面
                ToLogin();
              }
            }
          );
        } else {
          // 返回 401，并且不知用户操作活跃期内 清除token信息并跳转到登录页面
          ToLogin();
        }
      }
      // 403 无权限
      if (error.response.status == 403) {
        Vue.prototype.$message({
          message: "失败！该操作无权限",
          type: "error",
        });
        return null;
      }
      // 429 ip限流
      if (error.response.status == 429) {
        Vue.prototype.$message({
          message: "刷新次数过多，请稍事休息重试！",
          type: "error",
        });
        return null;
      }
    }
    return ""; // 返回接口返回的错误信息
  }
);

export const BaseApiUrl = base;

// 登录
export const requestLogin = (params) => {
  return axios
    .get(`${base}/api/login/jwttoken3.0`, { params: params })
    .then((res) => res.data);
};
export const requestLoginMock = (params) => {
  return axios.post(`${base}/login`, params).then((res) => res.data);
};

export const refreshToken = (params) => {
  return axios
    .get(`${base}/api/login/RefreshToken`, { params: params })
    .then((res) => res.data);
};

export const saveRefreshtime = (params) => {
  let nowtime = new Date();
  let lastRefreshtime = window.localStorage.refreshtime
    ? new Date(window.localStorage.refreshtime)
    : new Date(-1);
  let expiretime = new Date(Date.parse(window.localStorage.TokenExpire));

  let refreshCount = 1; //滑动系数
  if (lastRefreshtime >= nowtime) {
    lastRefreshtime = nowtime > expiretime ? nowtime : expiretime;
    lastRefreshtime.setMinutes(lastRefreshtime.getMinutes() + refreshCount);
    window.localStorage.refreshtime = lastRefreshtime;
  } else {
    window.localStorage.refreshtime = new Date(-1);
  }
};
const ToLogin = (params) => {
  store.commit("saveToken", "");
  store.commit("saveTokenExpire", "");
  store.commit("saveTagsData", "");
  window.localStorage.removeItem("user");
  window.localStorage.removeItem("NavigationBar");

  if (global.IS_IDS4) {
    applicationUserManager.login();
  } else {
    router.replace({
      path: "/login",
      query: { redirect: router.currentRoute.fullPath },
    });

    window.location.reload();
  }
};

export const getUserByToken = (params) => {
  return axios
    .get(`${base}/api/user/getInfoByToken`, { params: params })
    .then((res) => res.data);
};

export function testapi2() {
  console.log("api is ok.");
}

export const testapi = (pa) => {
  console.log("api is ok.");
};

// 用户管理
export const getUserListPage = (params) => {
  return axios.get(`${base}/api/user/get`, { params: params });
};
export const removeUser = (params) => {
  return axios.delete(`${base}/api/user/delete`, { params: params });
};
export const editUser = (params) => {
  return axios.put(`${base}/api/user/put`, params);
};
export const addUser = (params) => {
  return axios.post(`${base}/api/user/post`, params);
};
export const batchRemoveUser = (params) => {
  return axios.delete(`${base}/api/Claims/BatchDelete`, { params: params }); //没做
};

// 角色管理
export const getRoleListPage = (params) => {
  return axios.get(`${base}/api/role/get`, { params: params });
};
export const removeRole = (params) => {
  return axios.delete(`${base}/api/role/delete`, { params: params });
};
export const editRole = (params) => {
  return axios.put(`${base}/api/role/put`, params);
};
export const addRole = (params) => {
  return axios.post(`${base}/api/role/post`, params);
};

// 接口模块管理
export const getModuleListPage = (params) => {
  return axios.get(`${base}/api/module/get`, { params: params });
};
export const removeModule = (params) => {
  return axios.delete(`${base}/api/module/delete`, { params: params });
};
export const editModule = (params) => {
  return axios.put(`${base}/api/module/put`, params);
};
export const addModule = (params) => {
  return axios.post(`${base}/api/module/post`, params);
};

// 菜单模块管理
export const getPermissionListPage = (params) => {
  return axios.get(`${base}/api/permission/get`, { params: params });
};
export const getPermissionTreeTable = (params) => {
  return axios.get(`${base}/api/permission/GetTreeTable`, { params: params });
};
export const removePermission = (params) => {
  return axios.delete(`${base}/api/permission/delete`, { params: params });
};
export const editPermission = (params) => {
  return axios.put(`${base}/api/permission/put`, params);
};
export const addPermission = (params) => {
  return axios.post(`${base}/api/permission/post`, params);
};
export const getPermissionTree = (params) => {
  return axios.get(`${base}/api/permission/getpermissiontree`, {
    params: params,
  });
};
export const getPermissionIds = (params) => {
  return axios.get(`${base}/api/permission/GetPermissionIdByRoleId`, {
    params: params,
  });
};

export const addRolePermission = (params) => {
  return axios.post(`${base}/api/permission/Assign`, params);
};
export const getNavigationBar = (params) => {
  return axios
    .get(`${base}/api/permission/GetNavigationBar`, { params: params })
    .then((res) => res.data);
};

// Bug模块管理
export const getBugListPage = (params) => {
  return axios.get(`${base}/api/TopicDetail/get`, { params: params });
};
export const removeBug = (params) => {
  return axios.delete(`${base}/api/TopicDetail/delete`, { params: params });
};
export const editBug = (params) => {
  return axios.put(`${base}/api/TopicDetail/update`, params);
};
export const addBug = (params) => {
  return axios.post(`${base}/api/TopicDetail/post`, params);
};

// 博客模块管理
export const getBlogListPage = (params) => {
  return axios.get(`${base}/api/Blog`, { params: params });
};
export const getBlogDeatil = (params) => {
  return axios.get(`${base}/api/Blog/DetailNuxtNoPer`, { params: params });
};
export const editBlog = (params) => {
  return axios.put(`${base}/api/Blog/update`, params);
};
export const removeBlog = (params) => {
  return axios.delete(`${base}/api/Blog/delete`, { params: params });
};
export const addBlog = (params) => {
  return axios.post(`${base}/api/Blog`, params);
};
export const publishBlog = (params) => {
  return axios.get(`${base}/api/Blog/Publish`, { params: params });
};
export const unPublishBlog = (params) => {
  return axios.get(`${base}/api/Blog/UnPublish`, { params: params });
};

export const getPublishBlogListPage = (params) => {
  return axios.get(`${base}/api/Blog/GetPublish`, { params: params });
};

// 日志
export const getLogs = (params) => {
  return axios.get(`${base}/api/Monitor/get`, { params: params });
};
export const getRequestApiinfoByWeek = (params) => {
  return axios.get(`${base}/api/Monitor/GetRequestApiinfoByWeek`, {
    params: params,
  });
};
export const getAccessApiByDate = (params) => {
  return axios.get(`${base}/api/Monitor/GetAccessApiByDate`, {
    params: params,
  });
};
export const getAccessApiByHour = (params) => {
  return axios.get(`${base}/api/Monitor/GetAccessApiByHour`, {
    params: params,
  });
};
export const getServerInfo = (params) => {
  return axios.get(`${base}/api/Monitor/Server`, { params: params });
};
export const getAccessLogs = (params) => {
  return axios.get(`${base}/api/Monitor/GetAccessLogs`, { params: params });
};
export const getIds4UsersGrow = (params) => {
  return axios.get(`${base}/api/Monitor/GetIds4Users`, { params: params });
};
export const getActiveUsers = (params) => {
  return axios.get(`${base}/api/Monitor/GetActiveUsers`, { params: params });
};

// Task管理
export const getTaskListPage = (params) => {
  return axios.get(`${base}/api/TasksQz/get`, { params: params });
};
export const removeTask = (params) => {
  return axios.delete(`${base}/api/TasksQz/delete`, { params: params });
};
export const editTask = (params) => {
  return axios.put(`${base}/api/TasksQz/put`, params);
};
export const addTask = (params) => {
  return axios.post(`${base}/api/TasksQz/post`, params);
};

export const startJob = (params) => {
  return axios.get(`${base}/api/TasksQz/StartJob`, { params: params });
};
export const stopJob = (params) => {
  return axios.get(`${base}/api/TasksQz/StopJob`, { params: params });
};
export const reCovery = (params) => {
  return axios.get(`${base}/api/TasksQz/ReCovery`, { params: params });
};
export const pauseJob = (params) => {
  return axios.get(`${base}/api/TasksQz/PauseJob`, { params: params });
};
export const resumeJob = (params) => {
  return axios.get(`${base}/api/TasksQz/ResumeJob`, { params: params });
};

// ids4
export const getAchieveUsers_IS4 = (params) => {
  return axios.get(`${base}/is4api/GetAchieveUsers`, { params: params });
};

// 部门模块管理
export const getDepListPage = (params) => {
  return axios.get(`${base}/api/base_department/get`, { params: params });
};
export const removeDep = (params) => {
  return axios.delete(`${base}/api/base_department/delete`, { params: params });
};
export const editDep = (params) => {
  return axios.put(`${base}/api/base_department/put`, params);
};
export const addDep = (params) => {
  return axios.post(`${base}/api/base_department/post`, params);
};

// 费用类型模块管理
export const getCostTypeListPage = (params) => {
  return axios.get(`${base}/api/base_costtype/get`, { params: params });
};
export const removeCostType = (params) => {
  return axios.delete(`${base}/api/base_costtype/delete`, { params: params });
};
export const editCostType = (params) => {
  return axios.put(`${base}/api/base_costtype/put`, params);
};
export const addCostType = (params) => {
  return axios.post(`${base}/api/base_costtype/post`, params);
};

// 数据字典模块管理
export const getDictionaryListPage = (params) => {
  return axios.get(`${base}/api/dictionary/get`, { params: params });
};
export const removeDictionary = (params) => {
  return axios.delete(`${base}/api/dictionary/delete`, { params: params });
};
export const editDictionary = (params) => {
  return axios.put(`${base}/api/dictionary/put`, params);
};
export const addDictionary = (params) => {
  return axios.post(`${base}/api/dictionary/post`, params);
};

// 报销申请单模块管理
export const getRBListPage = (params) => {
  return axios.get(`${base}/api/reimbursement/get`, { params: params });
};
export const getRB = (params) => {
  return axios.get(`${base}/api/reimbursement/get/` + params);
};
export const removeRB = (params) => {
  return axios.delete(`${base}/api/reimbursement/delete`, { params: params });
};
export const editRB = (params) => {
  return axios.put(`${base}/api/reimbursement/put`, params);
};
export const addRB = (params) => {
  return axios.post(`${base}/api/reimbursement/post`, params);
};

export const getbudget = (params) => {
  return axios.post(`${base}/api/reimbursement/GetBudget`, params);
};

// export const checkRB = (params) => {
//   return axios.get(`${base}/api/reimbursement/check`, params);
// };

export const checkRB = (params) => {
  return axios.get(`${base}/api/reimbursement/check`, { params: params });
};

export const Crevoucher = (params) => {
  return axios.get(`${base}/api/reimbursement/Crevoucher`, { params: params });
};

export const RecheckRB = (params) => {
  return axios.get(`${base}/api/reimbursement/recheck`, { params: params });
};

export const SubmitRB = (params) => {
  return axios.get(`${base}/api/reimbursement/submit`, { params: params });
};

export const ReSubmitRB = (params) => {
  return axios.get(`${base}/api/reimbursement/resubmit`, { params: params });
};

export const PushRB2 = (params) => {
  return axios.post(`${base}/api/reimbursement/push`, params);
};

export const PushRB = (params) => {
  return axios.post(`${base}/api/reimbursement/push2`, params);
};

export const getReimburseReport = (params) => {
  return axios.get(`${base}/api/reimbursement/ReimburseReport`, {
    params: params,
  });
};

//注册用户
export const addNewUser = (params) => {
  return axios.post(`${base}/api/Register/Post`, params);
};
//忘记密码，发送验证码至邮箱
export const PostVerCode = (params) => {
  return axios.post(`${base}/api/Register/PostVerCode`, params);
};
//获取验证码
export const GetVerCode = (params) => {
  return axios.post(`${base}/api/Register/GetVerCode`, params);
};
//重置密码
export const PostReset = (params) => {
  return axios.post(`${base}/api/Register/PostReset`, params);
};

//修改密码
export const editUserPassWord = (params) => {
  return axios.put(`${base}/api/user/UpdatePass`, params);
};

// 报销单管理
export const getListRBPage = (params) => {
  return axios.get(`${base}/api/listreimbursement/get`, { params: params });
};
export const removeListRB = (params) => {
  return axios.delete(`${base}/api/listreimbursement/delete`, {
    params: params,
  });
};
export const editListRB = (params) => {
  return axios.put(`${base}/api/listreimbursement/put`, params);
};
export const addListRB = (params) => {
  return axios.post(`${base}/api/listreimbursement/post`, params);
};

export const GetReimburseMentById = (params) => {
  return axios.get(
    `${base}/api/listreimbursement/GetReimburseMentById/` + params
  );
};

//发票
export const getListInvoicePage = (params) => {
  return axios.get(`${base}/api/invoiceinfo/get`, { params: params });
};
export const removeListInvoice = (params) => {
  return axios.delete(`${base}/api/invoiceinfo/delete`, {
    params: params,
  });
};

export const editListInvoice = (params) => {
  return axios.put(`${base}/api/invoiceinfo/put`, params);
};
export const addListInvoice = (params) => {
  return axios.post(`${base}/api/invoiceinfo/post`, params);
};

export const downloadReimburseReport = (tmpdata) => {
  return axios.get(`${base}/api/reimbursement/DownReimburseReport`, {
    params: {
      tmpdata: tmpdata, // 假设tmpdata需转换为JSON字符串传递
    },
    responseType: "blob", // 设置响应类型为'blob'以接收二进制数据
    // headers: {
    //   // 添加任何必要的请求头，例如认证信息等
    //   Authorization: `Bearer ${storeTemp.state.token}`,
    // },
  });
};

export const GetOAData = (date) => {
  // 修复参数传递方式，将 searchCondition 作为查询参数传递
  return axios.get(`${base}/api/OA/GetOAData`, { 
    params: { 
      date: date 
    } 
  });
};

export const GetDownloadStatus = (taskid) => {
  return axios.get(`${base}/api/OA/GetDownloadStatus`, { 
    params: { 
      taskid: taskid 
    } 
  });
};

export const DownFile1 = (filename) => {
  return axios.post(`${base}/api/File/DownFile1`, null, {
    params: {
      filename: filename,
    },
    responseType: "blob",
  });
};